import React, { memo } from "react"
import { Div } from "atomize"
import { theme } from "../settings/config"

function Divider({ m = { y: "0.5rem" }, w, borderColor, rounded = "circle", p }) {
	return (
		<Div
			border={{ b: w }}
			m={m}
			borderColor={borderColor ?? theme.colors.background}
			rounded={rounded}
		/>
	)
}

export default memo(Divider)
